import { toArray } from "../fable-library-js.4.24.0/Seq.js";
import { ofArray } from "../fable-library-js.4.24.0/List.js";
import { class_type } from "../fable-library-js.4.24.0/Reflection.js";

/**
 * The unique identifier for the item used by the overflow manager.
 */
export function overflowItem_id_Z721C83C5(value) {
    return ["id", value];
}

export function dataGrid_items_Z6D8BD2B8(value) {
    return ["items", toArray(value)];
}

export function flatTreeModule_getProps(options) {
    let value_6, value_8, value_10;
    let selectionMode;
    const matchValue = options.selectionMode;
    selectionMode = ((matchValue === "multiselect") ? ["selectionMode", "multiselect"] : ((matchValue === "single") ? ["selectionMode", "single"] : ["selectionMode", "undefined"]));
    return ofArray([(value_6 = options.onOpenChange, ["onOpenChange", (delegateArg, delegateArg_1) => {
        value_6(delegateArg, delegateArg_1);
    }]), (value_8 = options.onNavigation, ["onNavigation", (delegateArg_2, delegateArg_1_1) => {
        value_8(delegateArg_2, delegateArg_1_1);
    }]), selectionMode, (value_10 = options.onCheckedChange, ["onCheckedChange", (delegateArg_3, delegateArg_1_2) => {
        value_10(delegateArg_3, delegateArg_1_2);
    }]), ["openItems", options.openItems], ["checkedItems", options.checkedItems]]);
}

export function treeItemModule_getProps(options) {
    return ofArray([["value", options.value], ["itemType", options.itemType], ["parentValue", options.parentValue], ["aria-level", options["aria-level"]], ["aria-setsize", options["aria-setsize"]], ["aria-posinset", options["aria-posinset"]]]);
}

/**
 * Popovers are rendered out of DOM order on document.body by default, use this to render the popover in DOM order
 */
export function teachingPopover_inline$0027_Z1FBCCD16(value) {
    return ["inline", value];
}

export class presenceMotionSlotWithCollapseMotion_density {
    constructor() {
    }
}

export function presenceMotionSlotWithCollapseMotion_density_$reflection() {
    return class_type("FS.FluentUI.presenceMotionSlotWithCollapseMotion.density", undefined, presenceMotionSlotWithCollapseMotion_density);
}

//# sourceMappingURL=Props2.fs.js.map
